import { apiFetch } from './client'
import type { UserDeviceEnrollment } from '@isapi/shared'

export async function getEnrollments(userId: string): Promise<UserDeviceEnrollment[]> {
  return apiFetch(`/users/${userId}/enrollments`)
}

export async function enrollUserToDevices(
  userId: string,
  deviceIds: string[],
): Promise<{ enrollments: { id: string; device_id: string; status: string }[] }> {
  return apiFetch(`/users/${userId}/enrollments`, {
    method: 'POST',
    body: JSON.stringify({ deviceIds }),
  })
}

export async function removeEnrollment(userId: string, deviceId: string): Promise<void> {
  await apiFetch(`/users/${userId}/enrollments/${deviceId}`, { method: 'DELETE' })
}

export async function retryEnrollment(userId: string, deviceId: string): Promise<void> {
  await enrollUserToDevices(userId, [deviceId])
}

export async function setEnrollmentStatus(
  userId: string,
  deviceId: string,
  status: 'active' | 'pending' | 'blocked',
): Promise<void> {
  await apiFetch(`/users/${userId}/enrollments/${deviceId}`, {
    method: 'PATCH',
    body: JSON.stringify({ status }),
  })
}
